import { ShareClipboardDataType } from "./share-variants/ShareClipboard";
import { ShareDownloadDataType } from "./share-variants/ShareDownload";
import { ShareIMessageDataType } from "./share-variants/ShareIMessage";
import { ShareInstagramDMDataType } from "./share-variants/ShareInstagramDM";
import { ShareInstagramStoryDataType } from "./share-variants/ShareInstagramStory";
import { ShareShareDataType } from "./share-variants/ShareShare";

export type ShareType =
	| "Url"
	| "Image"
	| "MultiImage"
	| "Text"
	| "LivePhoto"
	| "MultiLivePhoto"
	| "Video";

export interface SharePayloadBase {
	type: ShareType;
	successAmplitude?: {
		eventName: string;
		eventProperties?: Record<string, any>;
	};
}

export interface ShareUrlPayload extends SharePayloadBase {
	type: "Url";
	url: string;
}

export interface ShareImagePayload extends SharePayloadBase {
	type: "Image";
	url: string;
	optimizedUrl?: string;
	/**
	 * Used to share an attached link with the image. Ex: Instagram story with a link automatically attached
	 */
	accompanyingAssetShareUrl?: string;
}

export interface ShareLivePhotoPayload extends SharePayloadBase {
	type: "LivePhoto";
	url: string;
	optimizedUrl?: string;
	videoUrl: string;
}

export interface ShareTextPayload extends SharePayloadBase {
	type: "Text";
	text: string;
}

export interface ShareVideoPayload extends SharePayloadBase {
	type: "Video";
	videoUrl: string;
	/**
	 * Used to share an attached link with the image. Ex: Instagram story with a link automatically attached
	 */
	accompanyingAssetShareUrl?: string;
}

export type SharePayload =
	| ShareUrlPayload
	| ShareImagePayload
	| ShareTextPayload
	| ShareLivePhotoPayload
	| ShareVideoPayload;

type PickIndividualSharePayload<T extends ShareType> = Extract<SharePayload, { type: T }>;

export type PickSharePayloadData<T extends readonly ShareType[] | ShareType[]> = SharePayloadData<
	T[number]
>;

export type SharePayloadData<T extends ShareType = ShareType> = PickIndividualSharePayload<T>[];

export type SharePayloadProp = {
	data: SharePayload[];
};

/**
 * Helper noop to help with type inference
 */
export const typeParseData = <T extends ShareType>(
	data: SharePayloadData,
	type: T,
): PickSharePayloadData<T[]> => data as PickSharePayloadData<T[]>;

export type ValidShareOption =
	| {
			key: "ShareDownload";
			data: ShareDownloadDataType;
	  }
	| {
			key: "ShareClipboard";
			data: ShareClipboardDataType;
	  }
	| {
			key: "ShareShare";
			data: ShareShareDataType;
	  }
	| {
			key: "ShareIMessage";
			data: ShareIMessageDataType;
	  }
	| {
			key: "ShareInstagramStory";
			data: ShareInstagramStoryDataType;
	  }
	| {
			key: "ShareInstagramDM";
			data: ShareInstagramDMDataType;
	  };
